import Vue from "vue";
import Component from "vue-class-component";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { CongeDto } from "../../../dto/GenApi.iNotPaie.Dto/CongeDto";
import moment from "moment";
import DoubleCalendrier from "./doubleCalendrier/doubleCalendrier";
import { CompteursAbsenceDto } from "../../../dto/GenApi.iNotPaie.Dto/CompteursAbsenceDto";
import { ParametresInstance } from "../../Controls/Parameters";
import { ValideurCongesDto } from "../../../dto/GenApi.iNotPaie.Dto/ValideurCongesDto";
import { UtilisateurDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurDto";

@Component({
	components: {
		SituationSalarie: require("../../gestionDesAbsences/situationDesAbsences/tableaux/situationSalarie/situationSalarie.vue.html"),
		DoubleCalendrier: require("./doubleCalendrier/doubleCalendrier.vue.html"),
		DetailAbsence: require("./detailAbsence/detailAbsence.vue.html"),
		ValidationAbsence: require("./validationAbsence/validationAbsence.vue.html")
	}
})
export default class AbsencesSalarieComponent extends Vue {
	public compteurAbsencesSalarie?: CompteursAbsenceDto = undefined;
	public listeValideursConges: ValideurCongesDto[] = [];
	public listeUtilisateurs: UtilisateurDto[] = [];
	public doubleCalendrier?: DoubleCalendrier;
	public listAbsenceSalarie: CongeDto[] = [];
	public dataReadyCompteurs = false;
	public currentId = 0;
	public currentMonth = 0;
	public currentYear = 0;
	public dataReady = false;
	public anneeCouranteConges = new Date().getFullYear();
	public currentDate: Date = new Date();
	public firstDate: Date = new Date();
	public lastDate: Date = new Date();

	public reloadData(id: number): void {
		this.currentId = id;
		this.reset();
	}

	public mounted(): void {
		this.reset();

		if (this.doubleCalendrier == undefined) {
			this.doubleCalendrier = this.$refs.doubleCalendrier as DoubleCalendrier;
		}
	}

	public reset(): void {
		this.currentDate = new Date();
		this.setData();
		this.fetchData();
	}

	public fetchData(): void {
		this.dataReadyCompteurs = false;

		if (ParametresInstance.societeCourante != undefined) {
			this.anneeCouranteConges = ParametresInstance.societeCourante.AnneeCongesEnCours - 1;
		}

		// COMPTEURS
		if (this.currentId != 0) {
			ServicesFactoryInstance.CompteurAbsenceService.getFicheSalarieAbsence(this.currentId, data => {
				if (data == undefined) {
					return;
				}

				this.compteurAbsencesSalarie = data.CompteurAbsence;
				this.listeValideursConges = data.ListeValideursConges;
				this.listeUtilisateurs = data.ListeUtilisateurs;

				this.dataReadyCompteurs = true;
			}), () => {
				this.dataReadyCompteurs = true;
			};
		}
	}
	public setFirstDate(value: Date): void {
		this.firstDate = value;
	}

	public refreshListeValideursConges(): void {
		ServicesFactoryInstance.StatuAbsenceService.getListeValideursConges(this.currentId, data => {
			this.listeValideursConges = data;
			this.$forceUpdate();
		});
	}

	public setLastDate(value: Date): void {
		this.lastDate = value;
	}

	public setData(): void {
		this.dataReady = false;

		if (this.currentId != 0) {
			this.currentMonth = this.currentDate.getUTCMonth() + 1;
			this.currentYear = this.currentDate.getUTCFullYear();

			ServicesFactoryInstance.AbsencesService.GetCongesDoubleCalendrier(this.currentId, this.currentMonth, this.currentYear, data => {
				this.listAbsenceSalarie = data;
				this.dataReady = true;

				if (this.doubleCalendrier != undefined) {
					this.doubleCalendrier.testDisableButton();
				}
			});
		}
	}

	public reload(mois: any, annee: any): void {
		this.currentDate = new Date(annee, mois);
		this.setData();
	}

	public previous(): void {
		this.currentDate = moment.utc(this.currentDate).subtract(1, "M").toDate();
		this.setData();
	}

	public next(): void {
		this.currentDate = moment.utc(this.currentDate).add(1, "M").toDate();
		this.setData();
	}

	public refreshAbsence(): void {
		this.fetchData();
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/absences/absences.ts